module.exports = __webpack_public_path__ + "images/_/programs/h2whoa/images/ppa_presents.fr_CA-42f6e3f2450b839eaf54d062274ca9ff.png";


//////////////////
// WEBPACK FOOTER
// ./programs/h2whoa/images/ppa_presents.fr_CA.png
// module id = 2397
// module chunks = 2